export const getLocationTime = (location: string, date: Date) =>
  `${location ? location + ' • ' : ''}${date.toString().slice(0, 11)} • ${date
    .toTimeString()
    .slice(0, 5)}`
